import { EstateProgramData } from '../types';

import { PREPARE_PROGRAM_FACTS_EMPTY_STATE } from '../constants';

export const prepareProgramValueFacts = (facts: EstateProgramData['facts']) => {
  if (!facts) {
    return PREPARE_PROGRAM_FACTS_EMPTY_STATE;
  }

  return facts.reduce<{
    time: string;
    investment: string;
  }>((acc, item) => {
    const title = item.title;

    const key = item.key;

    if (!title || !key) {
      return acc;
    }

    if (key === 'time' || key === 'investment') {
      return {
        ...acc,
        [key]: title,
      };
    }

    return acc;
  }, PREPARE_PROGRAM_FACTS_EMPTY_STATE);
};

export default prepareProgramValueFacts;
